import { Box } from '@mui/material';
import { ReactComponent as SunIcon48 } from '../assets/icons/48/sun.svg';
import { ReactComponent as MoonIcon48 } from '../assets/icons/48/moon.svg';
import { useThemeMode, THEME_MODES } from '../context/ThemeModeContext';

const ThemeSwitch = () => {
  const { themeMode, toggleThemeMode } = useThemeMode();
  const isDarkMode = themeMode === THEME_MODES.DARK;

  return (
    <Box
      sx={{ cursor: 'pointer', width: 48, height: 48 }}
      onClick={toggleThemeMode}
      aria-label={isDarkMode ? 'Activer le mode clair' : 'Activer le mode sombre'}
      role="button"
    >
      {isDarkMode ? <SunIcon48 /> : <MoonIcon48 />}
    </Box>
  );
};

export default ThemeSwitch;
